(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["venox-featured-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getSelectedOption(select) {
      if (!select) return null;
      return select.options[select.selectedIndex];
    }

    function setGallery(section, index) {
      var thumbs = section.querySelectorAll('[data-venox-thumb]');
      var panels = section.querySelectorAll('[data-venox-panel]');

      thumbs.forEach(function (thumb) {
        var isActive = thumb.getAttribute('data-venox-thumb') === String(index);
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-venox-panel') === String(index));
      });
    }

    function updateVariant(section) {
      var select = section.querySelector('[data-venox-variant-select]');
      var selected = getSelectedOption(select);
      if (!selected) return;

      var price = section.querySelector('[data-venox-price]');
      var compare = section.querySelector('[data-venox-compare]');
      var availability = section.querySelector('[data-venox-availability]');
      var stockFill = section.querySelector('[data-venox-stock-fill]');
      var submit = section.querySelector('[data-venox-submit]');
      var inventory = parseInt(selected.getAttribute('data-inventory'), 10) || 0;
      var available = selected.getAttribute('data-available') === 'true';
      var comparePrice = selected.getAttribute('data-compare') || '';

      if (price) price.textContent = selected.getAttribute('data-price') || '';
      if (compare) {
        compare.textContent = comparePrice;
        compare.classList.toggle('is-hidden', !comparePrice);
      }

      if (availability) {
        if (!available) {
          availability.textContent = 'Currently unavailable.';
        } else if (inventory > 0 && inventory <= 5) {
          availability.textContent = 'Hurry, limited stock available! Only ' + inventory + ' left in stock.';
        } else {
          availability.textContent = 'In stock and ready to ship.';
        }
      }

      if (stockFill) {
        var width = available ? Math.min(Math.max(inventory * 12, 18), 90) : 0;
        if (inventory <= 0 && available) width = 82;
        stockFill.style.setProperty('--venox-stock', width + '%');
      }

      if (submit) {
        submit.disabled = !available;
      }
    }

    function refreshCart() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    function initSection(section) {
      if (!section || section.dataset.venoxReady === 'true') return;
      section.dataset.venoxReady = 'true';

      section.querySelectorAll('[data-venox-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          setGallery(section, thumb.getAttribute('data-venox-thumb'));
        });

        thumb.addEventListener('mouseenter', function () {
          setGallery(section, thumb.getAttribute('data-venox-thumb'));
        });
      });

      var select = section.querySelector('[data-venox-variant-select]');
      if (select) {
        select.addEventListener('change', function () {
          updateVariant(section);
        });
      }

      var qtyInput = section.querySelector('.venox-featured-buy__qty-input');
      var minus = section.querySelector('[data-venox-qty-minus]');
      var plus = section.querySelector('[data-venox-qty-plus]');

      if (qtyInput && minus) {
        minus.addEventListener('click', function () {
          var current = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = Math.max(current - 1, 1);
        });
      }

      if (qtyInput && plus) {
        plus.addEventListener('click', function () {
          var current = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = current + 1;
        });
      }

      var form = section.querySelector('[data-venox-form]');
      if (form) {
        form.addEventListener('submit', function (event) {
          var submit = form.querySelector('[data-venox-submit]');
          if (!submit || submit.disabled) return;

          event.preventDefault();

          var originalText = submit.textContent;
          submit.disabled = true;
          submit.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json'
            },
            body: new FormData(form)
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Cart add failed');
              return response.json();
            })
            .then(function () {
              submit.textContent = 'Added!';
              refreshCart();

              window.setTimeout(function () {
                submit.textContent = originalText;
                submit.disabled = false;
              }, 1600);
            })
            .catch(function () {
              submit.textContent = 'Try again';

              window.setTimeout(function () {
                submit.textContent = originalText;
                submit.disabled = false;
              }, 1800);
            });
        });
      }
    }

    document.querySelectorAll('[data-venox-featured-buy]').forEach(initSection);

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-venox-featured-buy]');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
